/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";
import { CmpCedarbubbleWrapper } from "../CmpCedarbubbleWrapper";
import "./style.css";

export const CmpErrorbubble = ({
  className,
  cmpCedarbubbleWrapperDivClassName,
}) => {
  return (
    <div className={`cmp-errorbubble ${className}`}>
      <CmpCedarbubbleWrapper
        className="design-component-instance-node"
        divClassName={cmpCedarbubbleWrapperDivClassName}
      />
    </div>
  );
};
